import cx from 'classnames'
import { CanView } from 'components/Can'
import { useCurrentWorkspace } from 'hooks/useCurrentWorkspace'
import { useFlipperFlag } from 'hooks/useFlipperFlag'
import { useState } from 'react'
import { observer } from 'mobx-react-lite'
import { useSelector } from 'react-redux'
import { RootState, UserRole } from 'types'
import { WorkspaceService } from 'api/services/WorkspaceService'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { useIsAdsFeatureEnabled } from 'screens/PaidAds/hooks'
import { SectionHeader } from '../SectionHeader/SectionHeader'
import { NavMenuPaidAdsItem } from '../NavMenu/Buttons/NavMenuPaidAdsItem'
import { NavMenuGoogleAdsItem } from '../NavMenu/Buttons/NavMenuGoogleAdsItem'
import { NavMenuSeoRelevanceItem } from '../NavMenu/Buttons/NavMenuSeoRelevanceItem'
import NavMenuStyles from '../NavMenu/NavMenu.module.scss'
import Styles from '../../WorkspaceDashboardSidebarContent.module.scss'

const Planning = observer(() => {
  const workspace = useCurrentWorkspace()
  const [expanded, setExpanded] = useState(true)
  const { isMobile } = useResponsiveDesign()
  const canSeePaidAds = useIsAdsFeatureEnabled()
  const canSeeGoogleAds = useFlipperFlag('google_ads_integration')
  const canSeeSeoRelevance = useFlipperFlag('seo_relevance_plan')

  const { sidebarLocked, floatingSidebar } = useSelector(
    ({ sidebar: { locked: sidebarLocked }, floatingSidebar }: RootState) => ({
      floatingSidebar,
      sidebarLocked,
    }),
  )

  if (!workspace || isMobile) return null

  const closeMobileSidebar = () => {
    if (isMobile && (sidebarLocked || floatingSidebar)) WorkspaceService.hideSidebar()
  }

  return (
    <div className={Styles.section}>
      <SectionHeader label="Reach" isExpanded={expanded} onPress={() => setExpanded((prev) => !prev)} />
      {expanded && (
        <ul className={cx(NavMenuStyles.navItemsList, Styles.sectionNavItemsList)}>
          {canSeePaidAds && (
            <CanView as={[UserRole.MEMBER, UserRole.ADMIN, UserRole.SUPER_ADMIN]} inWorkspace={workspace.id}>
              <li>
                <NavMenuPaidAdsItem workspaceId={workspace.id} onPress={closeMobileSidebar} />
              </li>
            </CanView>
          )}
          {canSeeGoogleAds && (
            <CanView as={[UserRole.MEMBER, UserRole.ADMIN, UserRole.SUPER_ADMIN]} inWorkspace={workspace.id}>
              <li>
                <NavMenuGoogleAdsItem workspaceId={workspace.id} onPress={closeMobileSidebar} />
              </li>
            </CanView>
          )}
          {canSeeSeoRelevance && (
            <CanView as={[UserRole.MEMBER, UserRole.ADMIN, UserRole.SUPER_ADMIN]} inWorkspace={workspace.id}>
              <li>
                <NavMenuSeoRelevanceItem workspaceId={workspace.id} onPress={closeMobileSidebar} />
              </li>
            </CanView>
          )}
        </ul>
      )}
    </div>
  )
})

export { Planning }
